// extracted by mini-css-extract-plugin
export default {"EditorDropzone":"EditorDropzone__bnr2A61ULBvm"};